export default __webpack_public_path__ + "static/media/character_blue.187dae9c.png";